import React, { useEffect } from "react";
import LeftSection from "../components/LeftSection";
import logoIcon from "../assets/images/logo-icon.png";
import ApiCall from "../common/ApiCall";
import "../assets/css/style.scss";
import "../assets/css/custom.css";

const AuthSplashLayout = ({ children }) => {
  // Fetch and inject analytics code
  useEffect(() => {
    const fetchAndInjectAnalytics = async () => {
      try {
        // Check if analytics script already exists
        const existingScript = document.getElementById("analytics-code");
        if (existingScript) {
          return; // Analytics already loaded, skip
        }

        const res = await ApiCall(
          "GET",
          "frontpage-content?type=analytics",
          null,
          null,
          true,
        );

        if (res?.data?.success && res.data.data.contents?.length > 0) {
          const analyticsData = res.data.data.contents[0];

          // Only inject if status is active
          if (analyticsData.status === 1 && analyticsData.text) {
            // Use a window property to prevent duplicate injection
            if (window.__analytics_injected) {
              return;
            }

            window.__analytics_injected = true;

            if (/<script/i.test(analyticsData.text)) {
              // HTML snippet - Parse and append children directly to head
              const range = document.createRange();
              const fragment = range.createContextualFragment(
                analyticsData.text,
              );
              document.head.appendChild(fragment);
            } else {
              // Plain JS - Create a single script tag
              const script = document.createElement("script");
              script.innerHTML = analyticsData.text;
              document.head.appendChild(script);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching analytics code:", error);
      }
    };

    fetchAndInjectAnalytics();
  }, []);

  return (
    <div className="main_section auth_layout">
      <div className="background-container">
        <div className="stars"></div>
        <div className="twinkling"></div>
        <div className="clouds"></div>
      </div>

      <div className="splash_layout">{children}</div>
    </div>
  );
};

export default AuthSplashLayout;
